import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'

const Select = props => {
  const [value, setValue] = useState(props.optionsLabel ? '' : props.value)
  const [required, setRequired] = useState(false)
  const [valid, setValid] = useState(false)

  useEffect(() => {
    setValue(props.optionsLabel ? '' : props.value)
  }, [props.optionsLabel, props.value])

  useEffect(() => {
    if (valid) {
      props.isValid({
        key: props.id,
        valid: true,
      })
    }
  }, [valid])

  const handleInvalid = e => {
    e.preventDefault()
    setRequired(true)
  }

  const handleChange = e => {
    if (props.forceLabelAfterSelected) {
      setValue(e.target.value)

      setTimeout(() => {
        setValue('')
      }, 500)
    } else {
      setValue(e.target.value)
    }

    if (required) {
      setRequired(false)
    } else {
      setValid(true)
    }
    props.onChange(e.target.value)
  }

  return (
    <div
      className={[
        midas.formGroup,
        required && midas.hasWarning,
        valid && midas.hasSuccess,
      ]
        .filter(val => val)
        .join(' ')}
      data-cy={props.dataCy}
    >
      {props.label && (
        <label className={midas.formLabel} htmlFor={props.id}>
          {props.label} {required && <span>*</span>}
        </label>
      )}

      <select
        {...{
          className: midas.formSelect,
          id: props.id,
          name: props.id,
          required: props.required,
          disabled: props.disabled,
          value,
          onChange: e => handleChange(e),
          onInvalid: e => !props.disabled && handleInvalid(e),
        }}
      >
        {props.optionsLabel && (
          <option disabled value="">
            {props.optionsLabel}
          </option>
        )}
        {props.values.map(val => (
          <option key={val.key} value={val.value}>
            {val.valueLabel}
          </option>
        ))}
      </select>
      {required && (
        <span className={midas.formInputHint}>{props.required}</span>
      )}
      {props.children}
    </div>
  )
}

Select.propTypes = {
  children: PropTypes.node,
  values: PropTypes.array,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  optionsLabel: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  forceLabelAfterSelected: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.string,
  onChange: PropTypes.func,
  isValid: PropTypes.func,
  dataCy: PropTypes.string,
}

Select.defaultProps = {
  children: null,
  values: [],
  label: null,
  optionsLabel: null,
  forceLabelAfterSelected: false,
  value: '',
  disabled: false,
  required: null,
  dataCy: null,
  onChange: () => {},
  isValid: () => {},
}

export default Select
